import { call, put, takeLatest, } from 'redux-saga/effects';
import { Urls } from 'src/common/urls';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { getErrorFromResponse } from 'src/features/Security/networking/util';
import { ServiceContractRecordsFilters } from 'src/common/models/contract';
import { ServiceContractDebitRecordsFilters } from 'src/common/models/serviceContractDebit';

function* createServiceContractApi(action: Actions.CreateServiceContractAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.SERVICE_CONTRACT.CREATE, action.serviceContract)
        yield put(Actions.createServiceContractApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.createServiceContractApiError(getErrorFromResponse(err)));
    }
}

const buildQueryString = (filters?: ServiceContractRecordsFilters) => {
    const filtersList: string[] = []
    if (filters?.isActive !== undefined) {
        filtersList.push(`active=${filters.isActive}`)
    }
    if (filters?.customerId) {
        filtersList.push(`customerId=${filters.customerId}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getContractsRecordsApi(action: Actions.GetServiceContractsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.SERVICE_CONTRACT.GET_RECORDS(buildQueryString(action.filters)))
        yield put(Actions.getServiceContractsApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getServiceContractsApiError(getErrorFromResponse(err)));
    }
}

const buildDebitsQueryString = (filters?: ServiceContractDebitRecordsFilters) => {
    const filtersList: string[] = []
    if (filters?.status) {
        filtersList.push(`status=${filters.status}`)
    }
    if (filters?.customerId) {
        filtersList.push(`customerId=${filters.customerId}`)
    }
    if (filters?.serviceContractId) {
        filtersList.push(`serviceContractId=${filters.serviceContractId}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getContractDebitRecordsApi(action: Actions.GetServiceContractDebitsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.SERVICE_CONTRACT_DEBIT.GET_RECORDS(buildDebitsQueryString(action.filters)))
        yield put(Actions.getServiceContractDebitsApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getServiceContractDebitsApiError(getErrorFromResponse(err)));
    }
}

function* getContractByIdApi(action: Actions.GetServiceContractByIdAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.SERVICE_CONTRACT.GET_BY_ID(action.id))
        yield put(Actions.getServiceContractByIdApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getServiceContractByIdApiError(getErrorFromResponse(err)));
    }
}

function* getContractDebitByIdApi(action: Actions.GetContractDebitByIdAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.SERVICE_CONTRACT_DEBIT.GET_BY_ID(action.id))
        yield put(Actions.getContractDebitByIdApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getContractDebitByIdApiError(getErrorFromResponse(err)));
    }
}

function* updateServceContractApi(action: Actions.UpdateServiceContractAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().put, Urls.BACKEND.SERVICE_CONTRACT.UPDATE, action.serviceContract)
        yield put(Actions.updateServiceContractApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.updateServiceContractApiError(getErrorFromResponse(err)));
    }
}

function* deleteServiceContractDebitApi(action: Actions.DeleteServiceContractDebitAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.SERVICE_CONTRACT_DEBIT.DELETE, { id: action.id })
        yield put(Actions.deleteServiceContractDebitApiSuccess(
            response.data
        ))
    } catch (err) {
        yield put(Actions.deleteServiceContractDebitApiError(getErrorFromResponse(err)));
    }
}

export default function* serviceContractSagas() {
    yield takeLatest(ActionTypes.CREATE_SERVICE_CONTRACT_API, createServiceContractApi)
    yield takeLatest(ActionTypes.GET_SERVICE_CONTRACTS_API, getContractsRecordsApi)
    yield takeLatest(ActionTypes.GET_CONTRACT_BY_ID_API, getContractByIdApi)
    yield takeLatest(ActionTypes.GET_SERVICE_CONTRACT_DEBITS_API, getContractDebitRecordsApi)
    yield takeLatest(ActionTypes.GET_CONTRACT_DEBIT_BY_ID_API, getContractDebitByIdApi)
    yield takeLatest(ActionTypes.UPDATE_SERVICE_CONTRACT_API, updateServceContractApi)
    yield takeLatest(ActionTypes.DELETE_SERVICE_CONTRACT_DEBIT_API, deleteServiceContractDebitApi)
}